var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('div',{staticClass:"pa-4"},[_c('h4',[_vm._v("My Bio")])]),_c('v-divider'),_c('div',{staticClass:"pa-4"},[_c('small',[_vm._v(" "+_vm._s(_vm.authUser.my_bio)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }